module.exports = __webpack_public_path__ + "media/images/landing/second/photo4-22ee8de43efa19270b30f73200daa151.jpg";